import { render, staticRenderFns } from "./excavate_statistics.vue?vue&type=template&id=50f06502&"
import script from "./excavate_statistics.vue?vue&type=script&lang=js&"
export * from "./excavate_statistics.vue?vue&type=script&lang=js&"
import style0 from "./excavate_statistics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports